var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tree',{attrs:{"value":_vm.courseLecturesTree,"draggable":false},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
return _c('span',{},[(node.node.entity.objectType === 'Lesson')?_c('router-link',{attrs:{"to":{
        name: 'lesson',
        params: { courseId: _vm.courseId, id: node.node.entity.id }
      }}},[_vm._v("\n      "+_vm._s(node.node.entity.title)+"\n      "),_c('i',{staticClass:"ml-1",class:_vm.getStatus(node.node.id)})]):_c('b',[_vm._v("\n      "+_vm._s(node.node.entity.title)+"\n    ")])],1)}}])})}
var staticRenderFns = []

export { render, staticRenderFns }